import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import Daily from './pages/Daily';
import Monthly from './pages/Monthly';
import Inventory from './pages/Inventory';
import Items from './pages/Items';
import Previous from './pages/Previous';
import PreviousAll from './pages/PreviousAll';
import Production from './pages/Production';
import ProductionRecords from './pages/ProductionRecords';
import SalesHome from './pages/SalesHome';
import SalesItems from './pages/SalesItems';
import SalesPrevious from './pages/SalesPrevious';
import SalesDaily from './pages/SalesDaily';
import SalesMonthly from './pages/SalesMonthly';
import ChooseWarehouse from './pages/ChooseWarehouse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import AboutUs from './pages/AboutUs';
import PermissionsManagement from './pages/PermissionsManagement';
import JoinTeam from './pages/JoinTeam';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/daily" element={<ProtectedRoute><Daily /></ProtectedRoute>} />
          <Route path="/monthly" element={<ProtectedRoute><Monthly /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
          <Route path="/items" element={<ProtectedRoute><Items /></ProtectedRoute>} />
          <Route path="/previous" element={<ProtectedRoute><Previous /></ProtectedRoute>} />
          <Route path="/previous-all" element={<ProtectedRoute><PreviousAll /></ProtectedRoute>} />
          <Route path="/production" element={<ProtectedRoute><Production /></ProtectedRoute>} />
          <Route path="/production-records" element={<ProtectedRoute><ProductionRecords /></ProtectedRoute>} />
          <Route path="/sales-home" element={<ProtectedRoute><SalesHome /></ProtectedRoute>} />
          <Route path="/sales-items" element={<ProtectedRoute><SalesItems /></ProtectedRoute>} />
          <Route path="/sales-previous" element={<ProtectedRoute><SalesPrevious /></ProtectedRoute>} />
          <Route path="/sales-daily" element={<ProtectedRoute><SalesDaily /></ProtectedRoute>} />
          <Route path="/sales-monthly" element={<ProtectedRoute><SalesMonthly /></ProtectedRoute>} />
          <Route path="/choose-warehouse" element={<ProtectedRoute><ChooseWarehouse /></ProtectedRoute>} />
          <Route path="/permissions" element={<ProtectedRoute><PermissionsManagement /></ProtectedRoute>} />
          <Route path="/join-team" element={<JoinTeam />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
